export default {
  title: 'Visão Geral',
  in_period: 'no período',
  of: '{a} de {b}',
  in_total: '{count} no total',
  subtitle: 'O essencial da conta em tempo real.',
  kpi: {
    devices: 'Dispositivos',
    devices_hint: 'Localizadores e rastreadores na conta',
    recently_detected: 'Detectadas agora',
    recently_detected_hint: 'Posição nos últimos 15 min',
    never_detected: 'Nunca detectadas',
    never_detected_hint: 'Aguardando primeira posição',
    unread_alerts: 'Alertas não lidos',
    unread_alerts_hint: 'Cercas, bateria e SOS',
    active_fences: 'Cercas ativas',
    active_fences_hint: 'Áreas monitoradas',
  },
  alerts_7d: {
    title: 'Alertas — últimos 7 dias',
    subtitle: 'Entradas e saídas de cerca, bateria e SOS por dia.',
    unread: 'não lidos',
    read: 'lidos',
    empty: 'Nenhum alerta no período.',
  },
  detection_state: {
    title: 'Estado dos dispositivos',
    subtitle: 'Quando cada dispositivo foi visto pela última vez.',
    total_devices: 'dispositivo | dispositivos',
    empty: 'Nenhum dispositivo cadastrado ainda.',
  },
  battery: {
    title: 'Bateria mais baixa',
    subtitle: 'Dispositivos que merecem atenção.',
    empty: 'Nenhum dispositivo reporta bateria.',
  },
  categories: {
    title: 'Por categoria',
    subtitle: 'Como a frota está distribuída.',
    empty: 'Nenhum dispositivo cadastrado ainda.',
  },
  chart: {
    alerts_by_day: 'Alertas por dia',
    day_total: '{count} alerta | {count} alertas',
    aria_alerts: '{count} alertas nos últimos 7 dias',
    day_tooltip: '{total} alerta(s) — {unread} não lido(s)',
  },
}
